
    <p-toast>
      <ng-template pTemplate="message" let-message>
        <div class="kv-toast corner-label-container">

          <div class="kv-toast-content">
            <div class="kv-toast-summary">{{ message.summary }}</div>
            <div class="kv-toast-detail">{{ message.detail }}</div>
          </div>

            <span
          class="corner-label corner-label--top-right"
          [ngClass]="{
            'success': message.severity === 'success',
            'error': message.severity === 'error',
            'warn': message.severity === 'warn'
          }">
          v{{ appVersion }}
        </span>

        </div>
      </ng-template>
    </p-toast>
  


// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/toastNotification/toastNotification.component.ts.ToastNotificationComponent.html